import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { isTabStale, markTabStale } from '@/shared/utils/staleTab';

const reloadWindow = () => window.location.reload();

/**
 * Once the tab is stale, the next in-app navigation becomes a full page load, which fetches the
 * release now running. Nothing is shown to the user. Vite reports a lazy import whose files are
 * gone as `vite:preloadError`.
 */
export default function ReloadWhenStale({ reloadPage = reloadWindow }) {
    const location = useLocation();
    const previousKey = useRef(location.key);

    useEffect(() => {
        window.addEventListener('vite:preloadError', markTabStale);
        return () => window.removeEventListener('vite:preloadError', markTabStale);
    }, []);

    useEffect(() => {
        if (location.key === previousKey.current) return;
        previousKey.current = location.key;
        if (isTabStale()) reloadPage();
    }, [location.key, reloadPage]);

    return null;
}
